import script from "./HighlightText.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightText.vue?vue&type=script&setup=true&lang=js"

import "./HighlightText.vue?vue&type=style&index=0&id=48b53616&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b53616"]])

export default __exports__